import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom'
import { loading, Updateloading } from "../../common/helpers/toastify";
import { _Api } from "../../common/api/_call"
import { useTranslation } from 'react-i18next';

export const openPosEmailModal = (event) => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  document.dispatchEvent(new CustomEvent("pos:openEmailModal"));
};

const BLOCKED_FOCUS_IDS = ["checkoutModal"];

const releaseBootstrapFocusTrap = () => {
  const Modal = window.bootstrap?.Modal;
  if (!Modal) return;
  const nodes = new Set([
    ...BLOCKED_FOCUS_IDS.map((id) => document.getElementById(id)).filter(Boolean),
    ...document.querySelectorAll(".modal"),
  ]);
  nodes.forEach((el) => {
    const inst = Modal.getInstance(el);
    if (!inst) return;
    inst._focustrap?.deactivate?.();
    inst.dispose();
  });
};

const setBackgroundModalsInert = (inert) => {
  BLOCKED_FOCUS_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (inert) {
      el.setAttribute("inert", "");
      el.setAttribute("aria-hidden", "true");
    } else {
      el.removeAttribute("inert");
      el.removeAttribute("aria-hidden");
    }
  });
};

const MailModal = (props) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const inputRef = useRef(null);
  const overlayRef = useRef(null);
  const [inputemail, setInputemail] = useState('')
  const [showmodal, setShowmodal] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const { type, email, id, setShoworder } = props

  useEffect(() => {
    const open = () => {
      setInputemail(email || '')
      setShowmodal(false)
      setIsOpen(true)
    }
    document.addEventListener("pos:openEmailModal", open)
    return () => document.removeEventListener("pos:openEmailModal", open)
  }, [email])

  useEffect(() => {
    if (!isOpen) return undefined;
    releaseBootstrapFocusTrap();
    setBackgroundModalsInert(true);

    const keepFocus = (event) => {
      const overlay = overlayRef.current;
      if (!overlay || overlay.contains(event.target)) return;
      event.stopImmediatePropagation();
      inputRef.current?.focus({ preventScroll: true });
    };
    document.addEventListener("focusin", keepFocus, true);

    const frame = window.setTimeout(() => {
      inputRef.current?.focus({ preventScroll: true });
    }, 0);

    return () => {
      window.clearTimeout(frame);
      document.removeEventListener("focusin", keepFocus, true);
      setBackgroundModalsInert(false);
    };
  }, [isOpen])

  const close = () => {
    setIsOpen(false)
    setShowmodal(false)
  }

  const sandemail = async () => {
    if (showmodal) return;
    setShowmodal(true)
    let GetloadingID = loading();
    try {
      let postdata = {
        "type": type,
        "email": inputemail ? inputemail : email,
        "id": id
      }
      let res = await _Api(postdata, `api/v1/POS/report/invoiceMail`);
      if (res.code === 200) {
        close();
        setShoworder?.(false);

        setTimeout(() => {
          Updateloading(t, GetloadingID, t("Successfully Email Sand"));
          navigate('/app/pos/menu');
        }, 100)
      } else {
        setShowmodal(false)
        Updateloading(t, GetloadingID, res?.errors || t("Something went wrong"), "error");
      }
    }
    catch (err) {
      setShowmodal(false)
      console.log(err, 'err');
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  }

  if (!isOpen) return null

  return createPortal(
    <div className="main-layout-pos pos-email-modal-root">
      <div
        className="email-modal-backdrop"
        onClick={close}
      />
      <div
        className="email-modal"
        id="emailmodal"
        ref={overlayRef}
        aria-labelledby="emailmodalLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog email-modal-dialog modal-dialog-centered">
          <div className="modal-content pt-0 px-0 pb-2 overflow-hidden">

            <div className="modal-header email-modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {t("Email")}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={close}
              ></button>
            </div>
            <div className="modal-body px-3 pt-4">
              <label className="email-modal-label d-block pb-2" htmlFor="pos-email-modal-input">{t("Email")}</label>
              <div className='placeholder-up-input'>
                <input
                  id="pos-email-modal-input"
                  ref={inputRef}
                  type="text"
                  inputMode="email"
                  className='placeholder-up-input-field'
                  value={inputemail}
                  autoComplete="off"
                  autoFocus
                  onChange={(e) => setInputemail(e.target.value)}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className={showmodal ? "com-btn btn-disabled" : "com-btn"}
                disabled={showmodal}
                onClick={sandemail}
              >
                {t("Send Email")}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default MailModal;
